/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリース GIFアニメーション
 * @export
 * @interface PressReleaseGifAnimation
 */
export interface PressReleaseGifAnimation {
    /**
     * GIFファイル名
     * @type {string}
     * @memberof PressReleaseGifAnimation
     */
    fileName: string;
    /**
     * 見出し
     * @type {string}
     * @memberof PressReleaseGifAnimation
     */
    caption?: string | null;
}

export function PressReleaseGifAnimationFromJSON(json: any): PressReleaseGifAnimation {
    return PressReleaseGifAnimationFromJSONTyped(json, false);
}

export function PressReleaseGifAnimationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseGifAnimation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['file_name'],
        'caption': !exists(json, 'caption') ? undefined : json['caption'],
    };
}

export function PressReleaseGifAnimationToJSON(value?: PressReleaseGifAnimation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_name': value.fileName,
        'caption': value.caption,
    };
}

